module.exports = __webpack_public_path__ + "img/Skirt-Back-B1-Da-Fc-Gc-Hc 后背.c48b86bf.png";